export default __webpack_public_path__ + "static/media/10.3.e2030da4.jpg";